export const ETAPAS = {
  FORMULARIO: 1,
  VERIFICACION: 2,
  LEGALIZACION: 3,
};
